module.exports = __webpack_public_path__ + "media/images/favicons/favicon-a50fab1c628516b645d3c6d82549ff66.png";